export enum REQUEST_TYPE {
  CONTACTS = 'CONTACTS',
  COMPANIES = 'COMPANIES',
}

export enum OWNER_TYPE {
  EMAIL_ADDRESS = 'USE_EMAIL_ADDRESS',
  NAME = 'USE_NAME',
  LIST = 'USE_LIST'
}

export enum APP_STATUS {
  ACTIVE = 'ACTIVE',
  DISABLED = 'INACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}

export enum APP_AVAILABILITY {
  ENABLED_FOR_ADMINS = 'ENABLED_FOR_ADMINS',
  ENABLED_FOR_ALL = 'ENABLED_FOR_ALL',
  DISABLED = 'DISABLED',
}

export enum APP_AVAILABILITY_TEXT {
  ENABLED_FOR_ADMINS = 'ENABLED FOR ADMINS',
  ENABLED_FOR_ALL = 'ENABLED FOR ALL',
  DISABLED = 'DISABLED',
}

export enum NOTIFICATION_TYPE {
  EMAIL = 'EMAIL',
}
